import { GraphqlError, GraphqlErrorEntry } from './api-error';

/** Тело GraphQL-ответа: `data` и/или `errors`. */
export interface GraphqlBody<T> {
  data?: T | null;
  errors?: GraphqlErrorEntry[];
}

/**
 * Единственный путь чтения GraphQL-ответа в репозитории: `unwrapGraphql(response.data).user`.
 *
 * Бэкенд отвечает на отказ `200`, `errors` и **без** `data` — прямое `response.data.data.X`
 * падает тогда в `TypeError` вместо причины. Здесь отказ превращается в `GraphqlError` с кодом
 * (`extensions.code`), а пустой ответ — тоже в ошибку. Частичный ответ (`data` вместе с
 * `errors`) считается отказом.
 */
export function unwrapGraphql<T>(body: GraphqlBody<T> | null | undefined): T {
  if (body?.errors && body.errors.length > 0) {
    throw new GraphqlError(body.errors);
  }
  if (body?.data === undefined || body.data === null) {
    throw new GraphqlError([], 'Empty GraphQL response');
  }
  return body.data;
}
